module.exports = __webpack_public_path__ + "img/dashboard2_w.0ff3da82.svg";